import { createReducer } from '@reduxjs/toolkit';
import {
    SET_PARTNERS_DATA,
    SET_IS_LOADING_PARTNERS,
} from '../actions/partnersActions';

const initialState = {
    partnersData: [],
    isLoading: true,
};

const partners = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_PARTNERS_DATA, (state, action) => {
            state.partnersData = action.partnersData;
        })
        .addCase(SET_IS_LOADING_PARTNERS, (state, action) => {
            state.isLoading = action.isLoading;
        });
});

export default partners;
